import { render, staticRenderFns } from "./mostClassPage.vue?vue&type=template&id=0df64ed0&scoped=true&"
import script from "./mostClassPage.vue?vue&type=script&lang=js&"
export * from "./mostClassPage.vue?vue&type=script&lang=js&"
import style0 from "./mostClassPage.vue?vue&type=style&index=0&id=0df64ed0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df64ed0",
  null
  
)

export default component.exports